import { Helpers } from '../../helpers';
import { ICostCenterType } from '../../interfaces/icost-center-type';
import { CostCenter } from '../cost-center';

export class CostCenterTypeBase {
  CostCenterTypeId: number;
  Description: string | null;
  CostCenterTypeCode: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCenters_CostCenterType?: Array<CostCenter> | null;

  constructor(item?: ICostCenterType) {
    if (item) {

      this.CostCenterTypeId = item.CostCenterTypeId;
      this.Description = item.Description;
      this.CostCenterTypeCode = item.CostCenterTypeCode;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCenters_CostCenterType = Helpers.createClassArray(CostCenter, item.CostCenters_CostCenterType);
    }
  }
}